import { render, staticRenderFns } from "./CallRouteForm.vue?vue&type=template&id=245c2bf9"
import script from "./CallRouteForm.vue?vue&type=script&lang=js"
export * from "./CallRouteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports